module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-page chat-page--conversation"
  }, [_c('div', {
    staticClass: "chat-conversation-header chat-hero"
  }, [_c('button', {
    staticClass: "chat-icon-button",
    attrs: {
      "title": _vm.locale.t('label_back')
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "ti-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-conversation-heading"
  }, [_c('h1', [_vm._v(_vm._s(_vm.getTitle()))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.locale.t('label_user_chat')))])])]), _vm._v(" "), _c('div', {
    ref: "messagesPanel",
    staticClass: "chat-panel chat-messages-panel",
    on: {
      "scroll": _vm.onMessagesScroll
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "chat-empty"
  }, [_vm._v(_vm._s(_vm.locale.t('label_loading')))]) : (_vm.errorMessage) ? _c('div', {
    staticClass: "form-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : (_vm.messages.length === 0) ? _c('div', {
    staticClass: "chat-empty"
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_messages')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chat-messages"
  }, [(_vm.isLoadingMoreMessages) ? _c('div', {
    staticClass: "chat-load-more"
  }, [_vm._v(_vm._s(_vm.locale.t('label_loading')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(message) {
    return _c('div', {
      key: message.id,
      staticClass: "chat-message",
      class: {
        'chat-message--mine': _vm.isMyMessage(message)
      }
    }, [_c('div', {
      staticClass: "chat-message-author"
    }, [_vm._v(_vm._s(_vm.getSenderName(message)))]), _vm._v(" "), _c('div', {
      staticClass: "chat-message-bubble"
    }, [_vm._v(_vm._s(message.message))]), _vm._v(" "), _c('div', {
      staticClass: "chat-message-time"
    }, [_vm._v(_vm._s(_vm.formatDate(message.createdAt)))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "chat-compose"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.locale.t('label_write_message')
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.sendMessage.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "chat-action-button chat-send-button",
    attrs: {
      "disabled": _vm.isSending || _vm.newMessage.trim().length === 0
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('i', {
    staticClass: "ti-location-arrow"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_send')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63ab01d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat/UserChatConversation.vue
// module id = 796
// module chunks = 0